import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("span", {
    ref: "reference",
    class: "relative inline-block cursor-pointer",
    onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.show && $setup.show(...args))),
    onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.hide && $setup.hide(...args)))
  }, [
    _createVNode(_component_Icon, {
      name: "info",
      class: "w-4 h-4 transform origin-center stroke-current text-[rgb(var(--color-primary-500))]"
    }),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createElementVNode("span", {
        ref: "floating",
        class: _normalizeClass(["p-2.5 text-gray-500 bg-white text-para-xs border rounded z-10 w-max max-w-[300px]", [
                    'fixed',
                    $setup.isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'
                ]])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ]))
  ], 544))
}